import { Theme } from '@mui/material/styles';

export const isValidHex = (color: string): boolean => {
  // Match hex strings like #RRGGBB or #RGB
  return /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(color);
};

// Use this instead of theme.palette.getContrastText to get contrast text color safely
export const getSafeContrastText = (theme: Theme, color: string): string => {
  // Default to white when color is invalid
  const defaultColor = '#FFF';
  const safeColor = isValidHex(color) ? color : defaultColor;

  return theme.palette.getContrastText(safeColor);
};
